import React from "react";

/**
 * Loading placeholder for `<IntroSection>` — rendered while the
 * `useIntro` hook is fetching admin-edited copy on a cold visit
 * (incognito, new device, cleared cache). Preserves the same shell
 * dimensions, gradient background, and grid layout so there is no
 * layout shift or "hardcoded fallback flash" when the real content
 * hydrates on the next frame. Same testId prefix so any Playwright
 * hooks around the wrapper stay valid; individual field testids
 * (title / body / bullets) only mount on the real IntroSection.
 */
export default function IntroSectionSkeleton({ testId = "intro-section" }) {
  return (
    <section
      data-testid={testId}
      data-testid-state="loading"
      aria-busy="true"
      aria-live="polite"
      className="on-dark rounded-3xl bg-gradient-to-br from-shell-side to-shell-side/95 text-white p-6 md:p-10 relative overflow-hidden animate-pulse"
    >
      <div className="absolute inset-x-0 top-0 h-1 grad-band" />
      <div className="grid lg:grid-cols-[minmax(0,1.05fr),minmax(0,1fr)] gap-8 items-center">
        <div>
          <div className="h-3 w-32 rounded-full bg-white/15" />
          <div className="mt-4 h-12 w-4/5 rounded-lg bg-white/15" />
          <div className="mt-3 h-12 w-3/5 rounded-lg bg-white/10" />
          <div className="mt-6 space-y-2">
            <div className="h-3 w-11/12 rounded bg-white/10" />
            <div className="h-3 w-10/12 rounded bg-white/10" />
            <div className="h-3 w-8/12 rounded bg-white/10" />
          </div>
          <div className="mt-6 h-9 w-40 rounded-full bg-white/20" />
        </div>
        <div>
          <div className="rounded-2xl bg-black/40 border border-white/10 overflow-hidden aspect-video" />
        </div>
      </div>
    </section>
  );
}
